import './custom/init';
import './components/notification';
import './galleries/infinite-loading';
import './custom/articleDate';
import './custom/google-analytics';
import notifications from './components/notification-data';
adw.notifications = notifications;
import './custom/load-ads';
import './custom/cf7-custom-validation';